/// <amd-module name="Build/Common/Library/ContributedExtension.types" />
import { Build, BuildDefinition } from "Build/Client/Contracts/Build";

export type BuildCallbackType = (build: Build) => void;
export type ArtifactAddedCallbackType = (buildId: number, artifactName: string) => void;
export type DefinitionCallbackType = (definition: BuildDefinition | undefined) => void;

export interface IDefinitionDetailContributionContext {
    /**
     * Required if reacting to the current definition.
     * More than one callbacks can be added, and all will be called.
     * It is important to have atleast one call back, since that's how an extension can get information about the current definition.
     */
    onDefinitionChanged: (handler: (definition: BuildDefinition | undefined) => void) => void;
}

/**
 * Pass down additional listeners so that consumers can "subscribe" to live events that are exposed here
 */
export interface ILiveContext {
    addArtifactAddedListener: (handler: ArtifactAddedCallbackType) => void;
    removeArtifactAddedListener: (handler: ArtifactAddedCallbackType) => void;
}

export interface ILegacyBuildResultsViewExtensionConfig {
    /**
        * Optional, If needed, this callback will be called when this particular extension is selected/displayed 
        */
    onViewDisplayed: (onDisplayedCallBack: () => void) => void;
    /**
    * Optional, for a given tab id, which can be fully qualified contribution id (publisher.extensionId.tabId) for tab or a well known tab id, 
    * the corresponding tab is selected if the tab is visible.
    */
    selectTab: (fullyQualifiedTabId: string) => void;
    /**
    * Optional, controls section visibility, call this method to hide or show sections. fullyQualifiedSectionId is of the format - publisher.extensionId.sectionId
    */
    setSectionVisibility: (fullyQualifiedSectionId: string, value: boolean) => void;
}

export interface IBuildResultsViewExtensionConfig extends ILegacyBuildResultsViewExtensionConfig {
    /**
    * Required if reacting to the current build.
    * More than one callbacks can be added, and all will be called.
    * It is important to have atleast one call back, since that's how an extension can get information about the current build.
    */
    onBuildChanged: (handler: (build: Build) => void) => void;

    /**
     * Gets optional live context if passed down by the provider
     */
    getLiveContext?: () => ILiveContext | undefined;

    /**
     * Optional callback added for internal contributions which can notify that their load is complete. 
     * Not exposing this for others as of now.
     * Currently it is used only by test contribution.
     */
    onExtensionRenderComplete?: (area: string, extensionName: string) => void
}